// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8e8866d2","703":"a2c3a6c4","787":"d89137ec"}[chunkId] + ".chunk.js";
};